// Typelizer digest a9e348668e61a969ef2778e6249eba69
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoices/:invoice_id/deliveries */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/deliveries', params, options),
    method: 'post',
  }),
}
